// extracted by mini-css-extract-plugin
export var content = "_bc-3";
export var list = "_bc-4";
export var settingsContent = "_bc-7";
export var settingsPanel = "_bc-8";
export var state = "_bc-6";
export var triggerBadge = "_bc-2";
export var triggerButton = "_bc-1";
export var triggerShell = "_bc-0";
export var unreadDot = "_bc-5";